import { useContext } from 'react';
import { RecipientsQuickSearchContext } from './recipients-quick-search-provider';

export const useRecipientsQuickSearch = () => {
    const recipientsQuickSearch = useContext(RecipientsQuickSearchContext);
    if (!recipientsQuickSearch) throw new Error("Couldn't find RecipientsQuickSearchContext");

    return recipientsQuickSearch;
};
